import { SHOW_HIDE_ANIMATION_DURATION, COUNTDOWN_ANIMATION } from './Toast.constants.js';

var closeAfterAnimation = function closeAfterAnimation(callback) {
  var id = setTimeout(function () {
    callback();
  }, SHOW_HIDE_ANIMATION_DURATION);
  return id;
};
var isCountdownAnimation = function isCountdownAnimation(event) {
  return event.animationName === COUNTDOWN_ANIMATION;
};

export { closeAfterAnimation, isCountdownAnimation };
//# sourceMappingURL=Toast.helper.js.map
